import type { ReactNode } from 'react';
import { ScrollReveal } from './ScrollReveal';

interface LegalPageLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  maxWidthClassName?: string;
  wrapInCard?: boolean;
}

export function LegalPageLayout({
  title,
  subtitle,
  children,
  maxWidthClassName = 'max-w-4xl',
  wrapInCard = true,
}: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-teal-50">
      <section className="py-20" style={{ paddingTop: '140px' }}>
        <div className={`${maxWidthClassName} mx-auto px-4 sm:px-6 lg:px-8 text-center`}>
          <ScrollReveal>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              {title}
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={1}>
            <p className="text-xl text-gray-600">
              {subtitle}
            </p>
          </ScrollReveal>
        </div>
      </section>

      <section className="pb-20" style={{ paddingBottom: '120px' }}>
        <div className={`${maxWidthClassName} mx-auto px-4 sm:px-6 lg:px-8`}>
          {wrapInCard ? (
            <ScrollReveal delay={2}>
              <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-lg">
                {children}
              </div>
            </ScrollReveal>
          ) : (
            <ScrollReveal delay={2}>
              <div>{children}</div>
            </ScrollReveal>
          )}
        </div>
      </section>
    </div>
  );
}
